module.exports = __webpack_public_path__ + "img/load.654b0dbe.svg";